export default __webpack_public_path__ + "static/media/background_right.2f9cabd8.png";